import React, { useCallback, useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { HandleNumber } from "../utils/Api";
import {
  setBasicData,
  setUserData,
  setLoading,
  setMainUser,
} from "../Redux/Actions/Actions";
import { toast } from "react-toastify";

// Move constants outside to prevent re-creation on every render
const ENTITY_ID_MAP = {
  snh: 12,
};

export default function EnterOtp() {
  const Basic = useSelector((state) => state.Basic);
  const [OTP, setSetOTP] = useState("");
  const [data, setData] = useState(null);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Track if the initial API call has been made to prevent double hits
  const initialized = useRef(false);

  const handleNumber = useCallback(
    async (code, number, providerCode) => {
      let entityId = null;
      if (providerCode) {
        entityId = ENTITY_ID_MAP[providerCode.toLowerCase()] || null;
      }

      try {
        const res = await HandleNumber({
          mobileCode: code,
          mobileNumber: number,
          NoOTPVerification: 11,
          entityId,
        });
        const d = await res.json();

        if (d.status === true) {
          setData(d);
        }
      } catch (error) {
        toast.error("Failed to send OTP. Please try again.");
      } finally {
        dispatch(setLoading({ loading: false, otp: false }));
      }
    },
    [dispatch],
  );

  useEffect(() => {
    // Prevent double execution in Strict Mode
    if (!initialized.current) {
      initialized.current = true;
      dispatch(setLoading({ loading: false, otp: false }));
      handleNumber(Basic.code, Basic.number, Basic.providerCode);
    }
  }, [handleNumber, Basic.code, Basic.number, Basic.providerCode, dispatch]);

  const handleOtpValidation = (d) => {
    // Logic check: ensure d and d.otp exist before comparing
    if (d && d.otp === OTP) {
      const { code, number, providerCode, profileCode } = Basic;
      const id = d.userID;

      dispatch(setLoading({ loading: true, otp: true }));
      dispatch(setUserData(d));

      const basicPayload = {
        type: d.type,
        id: id,
        code: code,
        mobileNumber: number,
        ConnectionID: id,
        rid: d.userID,
        authToken: d.authToken,
        providerCode,
        profileCode,
        ...(d.Gender != null && { Gender: d.Gender }), // Only add Gender if it exists
      };

      dispatch(setBasicData(basicPayload));
      dispatch(setMainUser(d));
      navigate("/name-details");
    } else {
      setSetOTP(""); // Corrected from setOtp (the local state setter)
      toast.error("Please enter correct OTP.");
      dispatch(setLoading({ loading: false, otp: false }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!OTP) return toast.error("Enter OTP to continue!");

    dispatch(setLoading({ loading: true, otp: false }));
    handleOtpValidation(data);
  };

  const handleResendOtp = () => {
    dispatch(setLoading({ loading: true, otp: false }));
    handleNumber(Basic.code, Basic.number, Basic.providerCode);
  };

  const handleEditNumber = () => {
    const searchParams = new URLSearchParams(window.location.search);
    if (!searchParams.has("providerCode") && !searchParams.has("providercode") && Basic.providerCode) {
      searchParams.set("providerCode", Basic.providerCode);
    }
    if (!searchParams.has("profile") && !searchParams.has("Profile") && Basic.profileCode) {
      searchParams.set("profile", Basic.profileCode);
    }
    const searchStr = searchParams.toString();
    navigate(searchStr ? `/?${searchStr}` : "/");
  };

  return (
    <div className="flex justify-center items-center text-thtext bg-gray-100">
      <div className="min-h-screen container items-center ">
        <div className="h-screen flex flex-col justify-start items-center ">
          <div className="max-w-md w-full h-44 bg-otpbg">
            <img
              className=" w-full h-full pt-5"
              src="./assets/otpmessage.svg"
              alt="OTP Illustration"
            />
          </div>
          <div className="px-8 pt-6 pb-8 max-w-md w-full h-full font-bold">
            <div className="flex flex-col justify-start items-start">
              <h2 className=" text-lg text-center mb-1">Verify your number</h2>
              <p className="text-sm mb-6">
                OTP sent to WhatsApp {Basic.code} {Basic.number}
              </p>
              <p
                onClick={handleEditNumber}
                className="text-secondary cursor-pointer text-sm mb-6"
              >
                Edit phone number
              </p>
            </div>
            <form
              className="flex flex-col justify-between h-3/4"
              onSubmit={handleSubmit}
            >
              <div className=" flex flex-col">
                <input
                  className="pt-2 focus:outline-none bg-transparent border-b border-gray-300 w-full text-center text-2xl"
                  type="text"
                  placeholder="Enter OTP"
                  value={OTP}
                  maxLength={6}
                  inputmode="numeric" pattern="[0-9]*"
                  required
                  onChange={(e) => setSetOTP(e.target.value)}
                />
                <div className="flex items-center justify-center mt-4 text-sm">
                  <h4
                    onClick={handleResendOtp}
                    className="text-secondary cursor-pointer"
                  >
                    Resend OTP
                  </h4>
                </div>
              </div>

              <button
                className="bg-primary h-12 text-white font-bold py-2 px-4 mt-6 rounded-full w-full"
                type="submit"
              >
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
